import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {getBoolValueByOnOffType} from '@/consts/uam/onOffTypes';
import {useDeviceSettingBase} from '@/containers/DevicesPage/components/DeviceSettings/hooks/useDeviceSettingBase';
import useDeviceSettingContent from '@/containers/DevicesPage/components/DeviceSettings/hooks/useDeviceSettingContent';

export const useSwitchSetting = (settingType, selector) => {
    const content = useDeviceSettingContent(settingType);
    const settingValue = useSelector(selector);

    const derived = useMemo(() => {
        if (!content) return null;

        const {type, notifications, values, popup, title} = content;
        const currentValue = values?.find((value) => value.value === settingValue) || values?.[0];

        return {
            notifications,
            type,
            currentValue,
            popup,
            popupCurrentValue: popup?.groups?.values?.[0],
            icon: currentValue?.icon,
            title,
        };
    }, [content, settingValue]);

    const {currentValue, popup, popupCurrentValue, icon, title} = derived || {};

    const boolValue = getBoolValueByOnOffType(currentValue?.value);

    const {uiValue, onChange, onSave} = useDeviceSettingBase({
        selector,
        valueConverter: () => boolValue,
        uiValueConverter: (value) => value,
        content: derived,
        autoSave: false, // Switch settings use manual save
    });

    const handleChange = (newValue) => onChange(newValue);

    return {
        onChange: handleChange,
        onSave,
        value: uiValue,
        currentValue,
        popup,
        popupCurrentValue,
        icon,
        title,
    };
};
